import { TESTIMONIAL_LIST, PARTNER_LIST, PROPERTY_ADS } from "../actions/types";

const initialState = {
  testimonialsList: [],
  partnerList: [],
  propertyAds: [],
  loading: true,
};

const homeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TESTIMONIAL_LIST:
      return {
        ...state,
        testimonialsList: payload,
        loading: false,
      };
    case PARTNER_LIST:
      return {
        ...state,
        partnerList: payload,
        loading: false,
      };
    case PROPERTY_ADS:
      return {
        ...state,
        propertyAds: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default homeReducer;
